import { Row } from 'antd';
import classNames from 'classnames';
import { CustomSpinProps } from '../../interfaces';
import styled from 'styled-components';
import CustomSpin from '.';

const LoadingWrapper = styled(Row)`
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;

  &.overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  &.mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    background-color: rgba(35, 37, 103, 0.1);
    z-index: 99;
  }
`;

type LoadingProps = CustomSpinProps & {
  mask?: boolean;

  /**
   * @default false
   * Loading should be component overlay or not
   */
  overlay?: boolean;
};

export const Loading = (props: LoadingProps) => {
  const { mask, overlay, size = 'large', ...rest } = props;
  return (
    <LoadingWrapper className={classNames({ mask, overlay })}>
      <CustomSpin {...rest} size={size} />
    </LoadingWrapper>
  );
};
